export default "__VITE_ASSET__2abe8cee__"